import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

const SKELETON_ROWS = 7;

/** Column widths of the shimmer cells, mirroring the people table's columns. */
const CELL_WIDTHS = ["70%", "55%", "80%", "45%"];

/**
 * The loading state of the suggestions table (mockup `tkPreviewSkeleton`). Shown
 * both on first load and while a "find different people" search runs, so the
 * table itself signals the work instead of the page swapping to a spinner.
 */
export const TrackTableSkeleton: FunctionComponent = () => {
	const { t } = useTranslation();

	return (
		<div
			className="overflow-hidden rounded-xl border border-gray-200"
			data-testid="track-table-skeleton"
		>
			<table className="w-full table-fixed">
				<tbody>
					{Array.from({ length: SKELETON_ROWS }, (_, row) => (
						<tr key={row} className="border-b border-gray-100 last:border-b-0">
							<td className="w-10 px-3 py-3">
								<div className="h-4 w-4 animate-pulse rounded bg-gray-100" />
							</td>
							{CELL_WIDTHS.map((width, cell) => (
								<td key={cell} className="px-3 py-3">
									<div className="h-3 animate-pulse rounded bg-gray-100" style={{ width }} />
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
			<div className="border-t border-gray-100 px-3 py-2.5 text-xs text-text-meta">
				{t("onboarding.track.loadingMatches")}
			</div>
		</div>
	);
};
